module.exports = __webpack_public_path__ + "media/images/khqr_small-d712172105b6f3738dd73d28e035cab8.png";